"use client";

import { Feld, type FeldEigenschaften } from "./feld";
import { HsAuswahl } from "./erweiterte-auswahl";
import { tagSymbolHtml, type HsOption, type TagFarbe } from "./auswahl-konfiguration";

/**
 * Tag-Auswahl (M-002 F8): Mehrfach-Chips (Preline `advanced-select-tags`) ohne Emoji und ohne Fremdbilder.
 * Statt des Bild-Avatars trägt jeder Tag einen Farbpunkt in einem von vier festen Farb-Tokens
 * (`primaer`, `gruen`, `orange`, `grau`; Rot bleibt Risiko-Zuständen vorbehalten, M-001). Welche Farbe ein Tag hat,
 * bestimmt der Aufrufer; der Baustein erfindet keine. Abweichung vom Original: AW-006.
 *
 * Tags stammen aus einer festen Liste (kein freies Anlegen im Feld). Der Wert geht als mehrfach gesetztes `name`
 * über das native Feld ins Formular. Der Baustein prüft nichts; der Aufrufer bietet nur Tags an, die die Action
 * zulässt (r109, r110).
 */
export interface TagOption {
  wert: string;
  label: string;
  farbe: TagFarbe;
}

export function TagAuswahl({
  tags,
  name,
  vorgabe,
  platzhalter = "Tags wählen",
  deaktiviert,
  beiAenderung,
  ...feld
}: FeldEigenschaften & {
  tags: TagOption[];
  name?: string;
  vorgabe?: string[];
  platzhalter?: string;
  deaktiviert?: boolean;
  beiAenderung?: (werte: string[]) => void;
}) {
  const optionen: HsOption[] = tags.map((t) => ({ wert: t.wert, label: t.label, symbolHtml: tagSymbolHtml(t.farbe) }));
  return (
    <Feld {...feld}>
      {(a) => (
        <>
          {/* Abweichung AW-006: Tag-Chips mit Farbpunkt in einem von vier festen Farb-Tokens statt Bild-Avatar */}
          <HsAuswahl
            attribute={a}
            modus="tags"
            optionen={optionen}
            platzhalter={platzhalter}
            mitSuche={false}
            name={name}
            vorgabe={vorgabe}
            deaktiviert={deaktiviert}
            beiAenderung={beiAenderung as ((wert: string | string[]) => void) | undefined}
          />
        </>
      )}
    </Feld>
  );
}
